import { NE_PRINT_LABEL_SOURCE } from 'domains/NuvemEnvioCommons/constants';
import { NUVEM_ENVIO_ORDERS_ROUTES } from '../routes';

export type BuildPrintNELabelPathProps =
  | BuildPrintNELabelPathFromOrdersListProps
  | BuildPrintNELabelPathFromOrderDetailsProps;

type BuildPrintNELabelPathFromOrdersListProps = {
  source: NE_PRINT_LABEL_SOURCE.ORDERS_LIST;
  fulfillmentOrderIds: string[];
};

type BuildPrintNELabelPathFromOrderDetailsProps = {
  source: NE_PRINT_LABEL_SOURCE.ORDER_DETAILS;
  orderId: string;
  fulfillmentOrderIds: string[];
};

export const buildPrintNELabelPath = (
  props: BuildPrintNELabelPathProps,
): string => {
  let callbackUrl = `${
    NUVEM_ENVIO_ORDERS_ROUTES.ordersNuvemEnvioPrintLabelStatus
  }?ids=${props.fulfillmentOrderIds.join(',')}&source=${props.source}`;

  if (props.source === NE_PRINT_LABEL_SOURCE.ORDER_DETAILS) {
    callbackUrl += `&orderId=${props.orderId}`;
  }

  return callbackUrl;
};
